import { Box } from '@mui/material'
import { C1Button } from 'c1ui'
import { Decision } from 'components/pages/task/action'
import { TaskActionButtonArgs } from 'components/pages/task/action/button'
import { canActOn } from 'components/pages/task/state'
import { TaskActionType } from 'pbts/c1/api/task/v1/task'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { TaskActionButton } from './styles'

export const MarkProvisionedActionButton = ({ task, onAction }: TaskActionButtonArgs): React.ReactElement | null => {
    const taskId = task.id

    if (!canActOn(task, TaskActionType.PROVISION_COMPLETE)) {
        return null
    }

    return (
        <Box sx={TaskActionButton.item}>
            <C1Button
                key={`components_task_list_mark_provisioned_option_${taskId}`}
                variant="outlined"
                color="primary"
                onClick={(): void => {
                    onAction(
                        {
                            decision: Decision.ProvisionComplete,
                            comment: '',
                            policyStepId: task.policy?.current?.id,
                        },
                        task,
                    )
                }}
                disabled={!canActOn(task, TaskActionType.PROVISION_COMPLETE)}
            >
                {task.type && task.type.taskType.oneofKind === 'grant' ? (
                    <FormattedMessage
                        id="component_task_list_mark_provisioned_option_label"
                        defaultMessage="Provisioned"
                    />
                ) : (
                    <FormattedMessage
                        id="component_task_list_mark_deprovisioned_option_label"
                        defaultMessage="Deprovisioned"
                    />
                )}
            </C1Button>
        </Box>
    )
}
